"use client"

import { useLanguage } from "../context/LanguageContext"
import "./AboutUs.css"

const AboutUs = () => {
  const { t, direction } = useLanguage()

  return (
    <div className="about-us-container" dir={direction}>
      <div className="about-us-hero">
        <div className="hero-content">
          <h1>{t("About WATref Calculator")}</h1>
          <p className="hero-subtitle">
            {t("Empowering farmers with precise evapotranspiration calculations for optimal irrigation management")}
          </p>
        </div>
      </div>

      <div className="about-us-content">
        <section className="mission-section">
          <div className="container">
            <div className="section-header">
              <h2>{t("Our Mission")}</h2>
              <p>
                {t(
                  "To provide farmers and agricultural professionals with accurate, easy-to-use tools for calculating reference evapotranspiration (WATref) and crop water requirements, enabling sustainable and efficient irrigation practices.",
                )}
              </p>
            </div>
          </div>
        </section>

        <section className="features-section">
          <div className="container">
            <h2>{t("What We Offer")}</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-calculator"></i>
                </div>
                <h3>{t("Precise Calculations")}</h3>
                <p>
                  {t("Advanced algorithms based on FAO-56 Penman-Monteith equation for accurate WATref calculations")}
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-cloud-sun"></i>
                </div>
                <h3>{t("Weather Integration")}</h3>
                <p>{t("Real-time weather data integration for up-to-date environmental conditions")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-seedling"></i>
                </div>
                <h3>{t("Crop Management")}</h3>
                <p>{t("Comprehensive crop database with growth stages and coefficient management")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>{t("Data Analytics")}</h3>
                <p>{t("Historical data analysis and trend visualization for informed decision making")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <h3>{t("Mobile Friendly")}</h3>
                <p>{t("Responsive design that works seamlessly across all devices")}</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-users"></i>
                </div>
                <h3>{t("Multi-User Support")}</h3>
                <p>{t("Team collaboration features with role-based access control")}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="technology-section">
          <div className="container">
            <div className="tech-content">
              <div className="tech-text">
                <h2>{t("Technology & Science")}</h2>
                <p>{t("Our platform is built on scientifically proven methodologies and cutting-edge technology:")}</p>
                <ul>
                  <li>{t("FAO-56 Penman-Monteith equation implementation")}</li>
                  <li>{t("Real-time meteorological data processing")}</li>
                  <li>{t("Advanced crop coefficient databases")}</li>
                  <li>{t("Machine learning for predictive analytics")}</li>
                  <li>{t("Cloud-based infrastructure for reliability")}</li>
                </ul>
              </div>
              <div className="tech-image">
                <i className="fas fa-cogs"></i>
              </div>
            </div>
          </div>
        </section>

        <section className="team-section">
          <div className="container">
            <h2>{t("Our Team")}</h2>
            <p className="team-intro">
              {t(
                "We are a dedicated team of agricultural engineers, software developers, and data scientists committed to advancing precision agriculture through technology.",
              )}
            </p>

            <div className="team-stats">
              <div className="stat-item">
                <div className="stat-number">10+</div>
                <div className="stat-label">{t("Years Experience")}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">1000+</div>
                <div className="stat-label">{t("Farmers Served")}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">{t("Countries")}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">{t("Support")}</div>
              </div>
            </div>
          </div>
        </section>

        <section className="values-section">
          <div className="container">
            <h2>{t("Our Values")}</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>{t("Accuracy")}</h3>
                <p>{t("We prioritize scientific accuracy in all our calculations and recommendations")}</p>
              </div>
              <div className="value-item">
                <h3>{t("Sustainability")}</h3>
                <p>{t("Promoting water conservation and sustainable farming practices")}</p>
              </div>
              <div className="value-item">
                <h3>{t("Innovation")}</h3>
                <p>{t("Continuously improving our platform with latest technologies")}</p>
              </div>
              <div className="value-item">
                <h3>{t("Accessibility")}</h3>
                <p>{t("Making advanced agricultural tools accessible to farmers worldwide")}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default AboutUs
